export default __webpack_public_path__ + "static/media/coop-logo-white.ae56898e.svg";